<div class="title">
  <div class="text">
    <ng-content></ng-content>
  </div>
</div>
